'use strict';
const _ = require('underscore');
module.exports = function googleAttachmentMetaData(item) {
	const result = _.pick(item, 'name', 'mimeType', 'url', 'description', 'embedUrl');
	if (!result.embedUrl) {
		result.embedUrl = item.thumbnails && _.sortBy(item.thumbnails, 'height').pop().url;
	} else {
		result.embedUrl = result.embedUrl.replace('export=download', '');
	}

	if (/^application\/vnd\.google-apps\.drive-sdk/.test(result.mimeType) && item.id) {
		result.url = 'https://drive.google.com/file/d/' + item.id;
	}
	return result;
};
